// extracted by mini-css-extract-plugin
export default {"modalView":"modalView__ModalView__xo8fQ","closeButton":"closeButton__ModalView__xo8fQ"};